import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import "./../bindings/filtering";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./bao-dialog";
import BaseAuditDialog from "./base-audit-dialog";
/**
 * Shows Audit Dialog For given ConfigurationItemId
 */
class TicketAuditDialog extends BaseAuditDialog {
    /** Url for Post for AuditCollection
     */
    GetAuditCollectionUrl = "TicketHistory/GetAuditCollection";
}
export default TicketAuditDialog;